import { dateIsPast } from "@circle-react/helpers/dateTimeHelpers";
import { dateStringToTimeAgo } from "@circle-react/helpers/dateTimeHelpers/timeAgo";
import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { t } from "@/i18n-js/instance";
import {
  anchorClassNames,
  legacyClassNames,
} from "@/react/helpers/cssAnchorHelpers";

import "./styles.scss";
import { STATUS } from "../helpers/constants";

interface CounterProps {
  endsAt: string;
  startsAt: string;
  status?: string | null;
}

export const Counter = ({ startsAt, endsAt, status = null }: CounterProps) => {
  const isDraft = status === STATUS.DRAFT;
  const isFinished = dateIsPast(endsAt);
  const isStarted = dateIsPast(startsAt);

  let label = null;
  if (isStarted && !isFinished && !isDraft) {
    label = t("events.details.in_progress");
  } else if (isDraft) {
    label = t("events.details.draft");
  } else if (isFinished) {
    label = t("events.details.finished", {
      time_string: dateStringToTimeAgo(endsAt),
    });
  } else {
    label = t("events.details.starts", {
      time_string: dateStringToTimeAgo(startsAt),
    });
  }

  return (
    <div
      className={classNames(
        anchorClassNames("event-counter-badge", {
          "event-counter-badge--finished": isFinished,
        }),
        isDraft && legacyClassNames("event-counter-badge--draft"),
      )}
    >
      {`${label}`}
    </div>
  );
};
